
import Marionette from "../../shared/marionette-mustache";
import {autoinject, Container} from "aurelia-dependency-injection";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import {AppEvents} from "../../app-events";
import { prop } from "../../decorators/property";
import {ImportModel} from "../models/Import";
import {IRequestOptions} from "../../search/interfaces/request-options";

@autoinject
export class FileStatusModel extends Backbone.AssociatedModel {

    @prop() public Title: string;
    @prop() public ProcessedDate: string;
    @prop() public DateCreated: string;

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/import-status/models/file-status.ts